
import EditPatientInfo from './EditPatientInfo';

const EditPatientPage = () => {

    return (
        <EditPatientInfo/>
    );
}

export default EditPatientPage;